import { apiGet } from 'api-service';
import { magicNumbers } from 'utils';
import {
  newsContentInitialState,
  instagramContentInitialState,
  instagramCommentByCommentContentInitialState,
  instagramCommentByPostContentInitialState,
  twitterContentInitialState,
  virastyContentInitialState,
  telegramContentInitialState,
  linkedinContentInitialState,
  newspaperContentInitialState,
  nativePlatformsContentInitialState,
  newsSearchResourceInitialState,
  instagramSearchResourceInitialState,
  twitterSearchResourceInitialState,
  virastySearchResourceInitialState,
  telegramSearchResourceInitialState,
  newspaperSearchResourceInitialState,
  filterInitialState,
  kioskInitialState,
  settingsInitialState,
  pageInitialState,
  vipResourceInitialState,
  chartInitialState,
  accountInitialState,
  contentInitialState,
  multPlatformContentInitialState,
  notificationInitialState,
} from './index';

const getAppInitialState = () => {
  return {
    multiPlatformContentReducer: multPlatformContentInitialState,
    newsContentReducer: newsContentInitialState,
    instagramContentReducer: instagramContentInitialState,
    instagramCommentByCommentContentReducer:
      instagramCommentByCommentContentInitialState,
    instagramCommentByPostContentReducer:
      instagramCommentByPostContentInitialState,
    twitterContentReducer: twitterContentInitialState,
    virastyContentReducer: virastyContentInitialState,
    telegramContentReducer: telegramContentInitialState,
    linkedinContentReducer: linkedinContentInitialState,
    newspaperContentReducer: newspaperContentInitialState,
    nativePlatformsContentReducer: nativePlatformsContentInitialState,
    newsSearchResourceReducer: newsSearchResourceInitialState,
    instagramSearchResourceReducer: instagramSearchResourceInitialState,
    twitterSearchResourceReducer: twitterSearchResourceInitialState,
    virastySearchResourceReducer: virastySearchResourceInitialState,
    telegramSearchResourceReducer: telegramSearchResourceInitialState,
    newspaperSearchResourceReducer: newspaperSearchResourceInitialState,
    filterReducer: filterInitialState,
    kioskReducer: kioskInitialState,
    settingsReducer: settingsInitialState,
    pageReducer: pageInitialState,
    vipResourcesReducer: vipResourceInitialState,
    chartReducer: chartInitialState,
    notificationReducer: notificationInitialState,
  };
};

export const migrations = {
  [magicNumbers.REDUX_PERSIST_VERSION_NUMBER]: (prevState) => {
    return {
      ...prevState,
      ...getAppInitialState(),
    };
  },
};

export const accountMigrations = {
  [magicNumbers.REDUX_PERSIST_ACCOUNT_SLICE_VERSION]: async (prevState) => {
    let response = null;
    response = await apiGet('/user/user');

    return {
      ...prevState,
      ...accountInitialState,
      currentUser: {
        ...prevState.currentUser,
        user: {
          ...prevState.currentUser.user,
          ...response?.data,
        },
      },
    };
  },
};

export const authMigrations = {
  [magicNumbers.REDUX_PERSIST_VERSION_NUMBER]: (prevState) => {
    return {
      ...prevState,
      ...contentInitialState,
      isLoggedIn: prevState.isLoggedIn,
    };
  },
};

export const contentMigrations = {
  [magicNumbers.REDUX_PERSIST_VERSION_NUMBER]: (prevState) => {
    return {
      ...prevState,
      ...contentInitialState,
    };
  },
};
